import { useEffect, useRef, useState } from 'react';
import type { NochePerfil } from '../nucleo/perfil';

export function GraficoNoches({ noches }: { noches: NochePerfil[] }) {
  const [fecha, setFecha] = useState(noches.at(-1)?.fecha);
  const lista = useRef<HTMLDivElement>(null);
  useEffect(() => { if (lista.current) lista.current.scrollLeft = lista.current.scrollWidth; }, []);
  if (!noches.length) return <p className="text-sm text-(--color-apagado)">No hay partidos en este período.</p>;
  const maximo = Math.max(...noches.map(n => n.partidos));
  const elegida = noches.find(n => n.fecha === fecha) ?? noches.at(-1)!;
  return <div role="group" aria-label="Gráfico de noches" className="flex flex-col gap-3">
    <p className="text-sm text-(--color-apagado)">Ganados y perdidos por fecha</p>
    <div className="flex gap-2">
      <div aria-hidden="true" className="relative h-40 w-4 shrink-0 text-[11px] text-(--color-apagado)">
        {[maximo, Math.floor(maximo / 2), 0].filter((v, i, lista) => lista.indexOf(v) === i).map(v =>
          <span key={v} className="absolute -translate-y-1/2" style={{ top: `${134 - v / maximo * 104}px` }}>{v}</span>)}
      </div>
      <div ref={lista} tabIndex={0} aria-label="Noches jugadas. Desplazá para ver fechas anteriores."
        className="flex min-w-0 flex-1 gap-1 overflow-x-auto pb-1">
        {noches.map(n => <button key={n.fecha} type="button" aria-pressed={elegida.fecha === n.fecha}
          aria-label={`${n.fecha}: ${n.ganados} ganados y ${n.perdidos} perdidos`}
          onClick={() => setFecha(n.fecha)} className={`flex h-40 min-w-12 flex-1 flex-col items-center justify-end
            rounded-lg border px-1 pt-5 focus-visible:outline-2 focus-visible:outline-(--color-texto)
            ${elegida.fecha === n.fecha ? 'border-(--color-acento) bg-(--color-acento)/10' : 'border-transparent'}`}>
          <div aria-hidden="true" className="relative flex w-7 shrink-0 flex-col justify-end"
            style={{ height: `${(n.partidos / maximo) * 104}px` }}>
            <span className="absolute -top-5 w-full text-center text-xs font-semibold tabular-nums">{n.partidos}</span>
            {n.perdidos > 0 && <span className="flex items-center justify-center bg-(--color-apagado) text-[10px] text-(--color-sobre-acento)"
              style={{ height: `${n.perdidos / n.partidos * 100}%` }}>{n.perdidos / maximo * 104 >= 12 ? n.perdidos : ''}</span>}
            {n.ganados > 0 && <span className="flex items-center justify-center bg-(--color-acento) text-[10px] text-(--color-sobre-acento)"
              style={{ height: `${n.ganados / n.partidos * 100}%` }}>{n.ganados / maximo * 104 >= 12 ? n.ganados : ''}</span>}
          </div>
          <span className="pt-1 text-[11px] text-(--color-apagado)">{dia(n.fecha)}</span>
        </button>)}
      </div>
    </div>
    <div className="flex justify-center gap-4 text-xs text-(--color-apagado)">
      <span className="flex items-center gap-1.5"><i className="h-2.5 w-2.5 bg-(--color-acento)" />Ganados</span>
      <span className="flex items-center gap-1.5"><i className="h-2.5 w-2.5 bg-(--color-apagado)" />Perdidos</span>
    </div>
    <p aria-live="polite" className="rounded-xl border border-(--color-borde) px-3 py-2 text-center text-sm">
      <b>{dia(elegida.fecha)} · {elegida.ganados} ganados, {elegida.perdidos} perdidos</b>
      <span className="block text-xs text-(--color-apagado)">Tocá una barra para ver esa noche.{noches.length > 5 && ' Deslizá para ver las anteriores.'}</span>
    </p>
  </div>;
}
function dia(fecha: string) { const [ano, mes, d] = fecha.split('-'); return `${Number(d)}/${Number(mes)}/${ano?.slice(2)}`; }
